import { useState, useEffect } from 'react';
import { fetchLeaderBoardStream } from '../apiservices/axiosservice/gameservice';
import { updatedLeaderBoard } from '../utils/shareUtils';
import { useSse } from '../sse';

/**
 * Consolidates leaderboard fetching (API) and real-time updates (SSE).
 * Replaces the duplicated pattern across PlayerLobby, PlayerGeoPlay,
 * GeoGameOver, HostGeoPlay, GameLobby, etc.
 */
export function useLeaderboard(gameId: string | undefined) {
  const [leaderboard, setLeaderboard] = useState<LeaderboardEntry[]>([]);
  const leaderboardUpdate = useSse<any>('leaderboard-update');

  // Initial fetch
  useEffect(() => {
    if (!gameId) return;
    fetchLeaderBoardStream(gameId)
      .then((res) => {
        const players = res.data?.leaderBoard || res.data || [];
        setLeaderboard(updatedLeaderBoard(players));
      })
      .catch(() => {});
  }, [gameId]);

  // SSE real-time updates
  useEffect(() => {
    if (!leaderboardUpdate) return;
    const players = leaderboardUpdate.leaderBoard || leaderboardUpdate || [];
    if (Array.isArray(players)) {
      setLeaderboard(updatedLeaderBoard(players));
    }
  }, [leaderboardUpdate]);

  return leaderboard;
}
